export default api => ({
    list: () => api.get('/templates'),
    download: (entity, format) => api.get(`/templates/${entity}/${format}`, {}, { responseType: 'blob' }),
    downloadData: (entity, keysFormat, params) => api.post(`/templates/${entity}/data?keysFormat=${keysFormat}`, params, { responseType: 'blob' }),
    downloadMultiEntity: () => api.get('/templates/multi-entity/xlsx', {}, { responseType: 'blob' }),
})
